import { render } from "./SidebarButton.vue?vue&type=template&id=6bbd0a7e&ts=true"
import script from "./SidebarButton.vue?vue&type=script&lang=ts"
export * from "./SidebarButton.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__